import { PropsWithChildren } from "react";
import ArrowRight from "@endya-conformite/ui-kit/src/assets/icons/arrow-right.svg?react";
import { Dropdown } from "@endya-conformite/ui-kit";
import styles from "./FilterDropdown.module.scss";

export function SortDropdown({ children }: PropsWithChildren) {
  return (
    <Dropdown
      content="Trier par"
      variant="text"
      icon={<ArrowRight />}
      className={styles.sortButton}
      dismissOnClick
    >
      {() => <div className={styles.filters}>{children}</div>}
    </Dropdown>
  );
}
